import { CardResponseMeta, List } from '@yleisradio/areena-types';
import { useSnowplow } from 'contexts/SnowplowContext';
import { useMemo } from 'react';
import { trackClick } from 'services/snowplowAnalytics/snowplowAnalytics';
import { GroupEngagementData } from './types';

export function useListEngagementData({
  cardPageMeta: meta,
  isPaginated,
  list: { title: label, style },
  listIndex,
}: {
  cardPageMeta: CardResponseMeta | undefined;
  isPaginated: boolean;
  list: List;
  listIndex: number;
}): GroupEngagementData {
  const length = meta?.count ?? null;
  const { source_ref, source_url } = meta?.analytics?.context?.yle || {};

  return useMemo(
    (): GroupEngagementData => ({
      isPaginated,
      label,
      length,
      index: listIndex,
      referer: source_ref,
      url: source_url,
      style,
    }),
    [isPaginated, label, length, listIndex, source_ref, source_url, style]
  );
}

export function useTrackCardClick(cardViewUuid: string): {
  trackCardClick: (() => void) | undefined;
  trackPlayButtonClick: (() => void) | undefined;
} {
  const { isSnowplowReady } = useSnowplow();

  if (!isSnowplowReady) {
    return {
      trackCardClick: undefined,
      trackPlayButtonClick: undefined,
    };
  }

  return {
    trackCardClick: () => {
      trackClick({ action: 'link', viewUuid: cardViewUuid });
    },
    trackPlayButtonClick: () => {
      trackClick({ action: 'play', viewUuid: cardViewUuid });
    },
  };
}

export function useViewUuid(): string {
  return useMemo(() => crypto.randomUUID(), []);
}
